import { motion } from "framer-motion";

const IMAGES = [
    {
        src: "https://static.wixstatic.com/media/d92b8c_998961dee7d9400ea5b569bcb1952a35~mv2.jpg/v1/fill/w_1600,h_1100,al_c,q_85,enc_auto/property.jpg",
        h: "tall",
        label: "Hill Country estate",
    },
    {
        src: "https://static.wixstatic.com/media/d92b8c_edd0d999ce91448bab8d00f1689dc6a0~mv2.jpg/v1/fill/w_1200,h_1100,al_c,q_85,enc_auto/bride.jpg",
        h: "short",
        label: "Ceremony moments",
    },
    {
        src: "https://static.wixstatic.com/media/d92b8c_498fe14258464c4cbe880a093e8464f4~mv2.jpg/v1/fill/w_1400,h_1000,al_c,q_85,enc_auto/hall_alt.jpg",
        h: "short",
        label: "Main hall reception",
    },
    {
        src: "https://static.wixstatic.com/media/d92b8c_2a1a3ba40f2344daa7201458da15291c~mv2.jpg/v1/fill/w_1400,h_1800,al_c,q_85,enc_auto/sunflower.jpg",
        h: "tall",
        label: "Van Gogh sunflower mosaic",
    },
    {
        src: "https://static.wixstatic.com/media/2ffe17_9723f2ce2eec44a188280dd07f3aea67~mv2.png/v1/fill/w_1200,h_1000,al_c,q_85,enc_auto/courtyard_g.png",
        h: "short",
        label: "Mosaic courtyard",
    },
    {
        src: "https://static.wixstatic.com/media/d92b8c_1fc352949a994339b1e1463363b00051~mv2.jpg/v1/fill/w_1200,h_1000,al_c,q_85,enc_auto/hall_main.jpg",
        h: "short",
        label: "Antique mirrors & piano",
    },
];

const HEIGHT_MAP = {
    tall: "h-[440px] sm:h-[640px]",
    short: "h-[280px] sm:h-[400px]",
};

export default function Gallery() {
    return (
        <section
            id="gallery"
            className="section-py container-px"
            data-testid="gallery-section"
        >
            <div className="flex flex-wrap items-end justify-between gap-6 mb-16">
                <div className="max-w-2xl">
                    <p className="overline">The Estate, in Frame</p>
                    <h2 className="mt-6 font-serif text-4xl sm:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight">
                        A gallery of <em className="italic text-[hsl(var(--primary))]">light, stone & celebration.</em>
                    </h2>
                </div>
                <p className="text-muted-foreground text-base max-w-sm font-light">
                    A glimpse of recent ceremonies, receptions and the quieter corners of
                    López Hill — captured by the couples themselves.
                </p>
            </div>

            <div className="columns-1 sm:columns-2 lg:columns-3 gap-6 [&>*]:mb-6">
                {IMAGES.map((img, i) => (
                    <motion.figure
                        key={i}
                        initial={{ opacity: 0, y: 24 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, delay: (i % 3) * 0.1 }}
                        viewport={{ once: true, margin: "-50px" }}
                        className="break-inside-avoid relative overflow-hidden group"
                        data-testid={`gallery-tile-${i}`}
                    >
                        <img
                            src={img.src}
                            alt={img.label}
                            className={`w-full ${HEIGHT_MAP[img.h]} object-cover transition-transform duration-[1500ms] group-hover:scale-[1.04]`}
                        />
                        <figcaption className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-black/70 to-transparent text-white text-xs uppercase tracking-[0.25em] opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                            {img.label}
                        </figcaption>
                    </motion.figure>
                ))}
            </div>
        </section>
    );
}
